<template>
  <SideBar title="Actualización de Datos">
    <div class="bg-white overflow-hidden shadow rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <div>
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Datos Personales
            </h3>
          </div>
          <div class="mt-4 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6">
            <div class="sm:col-span-2">
              <label
                for="input_dni"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                DNI
              </label>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="input_dni"
                  v-model="dni"
                  @change="validateDNI"
                  class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
                <div
                  class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                >
                  <IconSvg v-show="!dni_valid" solid="solid" icon="exclamation-circle" myClass="h-5 w-5 text-red-500"/>
                  <IconSvg
                  v-show="dni_valid"
                    solid="solid"
                    icon="check-circle"
                    myClass="h-5 w-5 text-green-500"
                  />
                </div>
              </div>
              <small v-if="error_dni" class="text-red-600">{{
                error_dni
              }}</small>
            </div>

            <div class="sm:col-span-2">
              <label
                for="input_age"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Edad
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  id="input_age"
                  type="number"
                  v-model="age"
                  class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
              <small v-if="error_age" class="text-red-600">{{
                error_age
              }}</small>
            </div>
            <div class="sm:col-span-2">
              <label
                for="photo"
                class="block text-sm leading-5 font-medium text-gray-700"
              >
                Foto de Perfil
              </label>
              <div class="mt-2 flex items-center">
                <!--span class="h-12 w-12 rounded-full overflow-hidden bg-gray-100">
                  <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </span-->
                <span class="rounded-md shadow-sm">
                  <button
                    type="button"
                    class="py-2 px-3 border border-gray-300 rounded-md text-sm leading-4 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
                  >
                    Seleccionar archivo
                  </button>
                </span>
              </div>
            </div>

            <div class="sm:col-span-6">
              <label
                for="input_first_name"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Nombre(s)
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  id="input_first_name"
                  v-model="first_name"
                  type="text"
                  class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
              <small v-if="error_first_name" class="text-red-600">{{
                error_first_name
              }}</small>
            </div>
            <div class="sm:col-span-3">
              <label
                for="input_last_name_p"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Apellido Paterno
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  id="input_last_name_p"
                  v-model="last_name_p"
                  class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
              <small v-if="error_last_name_p" class="text-red-600">{{
                error_last_name_p
              }}</small>
            </div>

            <div class="sm:col-span-3">
              <label
                for="input_last_name_m"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Apellido Materno
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  id="input_last_name_m"
                  v-model="last_name_m"
                  class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
              <small v-if="error_last_name_m" class="text-red-600">{{
                error_last_name_m
              }}</small>
            </div>
          </div>
        </div>
        <div class="mt-8 border-t border-gray-200 pt-6">
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Domicilio
            </h3>
          </div>
          <div class="mt-4 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6">
            <div class="sm:col-span-2">
              <label
                for="select_department"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Departamento
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <select
                  id="select_department"
                  v-model="department"
                  class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                >
                  <option disabled="" value="">Seleccionar</option>
                  <option>Lima</option>
                  <!--option value="01">Amazonas</option
                  ><option value="02">Áncash</option
                  ><option value="03">Apurímac</option
                  ><option value="04">Arequipa</option
                  ><option value="05">Ayacucho</option
                  ><option value="06">Cajamarca</option
                  ><option value="07">Callao</option
                  ><option value="08">Cusco</option
                  ><option value="09">Huancavelica</option
                  ><option value="10">Huánuco</option
                  ><option value="11">Ica</option
                  ><option value="12">Junín</option
                  ><option value="13">La Libertad</option
                  ><option value="14">Lambayeque</option
                  ><option value="15">Lima</option
                  ><option value="16">Loreto</option
                  ><option value="17">Madre de Dios</option
                  ><option value="18">Moquegua</option
                  ><option value="19">Pasco</option
                  ><option value="20">Piura</option
                  ><option value="21">Puno</option
                  ><option value="22">San Martín</option
                  ><option value="23">Tacna</option
                  ><option value="24">Tumbes</option
                  ><option value="25">Ucayali</option-->
                </select>
              </div>
              <small v-if="error_department" class="text-red-600">{{
                error_department
              }}</small>
            </div>

            <div class="sm:col-span-2">
              <label
                for="select_province"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Provincia
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <select
                  id="select_province"
                  v-model="province"
                  class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                >
                  <option disabled="" value="">Seleccionar</option>
                  <option value="01">Lima</option>
                </select>
              </div>
              <small v-if="error_province" class="text-red-600">{{
                error_province
              }}</small>
            </div>

            <div class="sm:col-span-2">
              <label
                for="select_district"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Distrito
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <select
                  id="select_district"
                  v-model="district"
                  class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                >
                  <option selected="" disabled="" value="">Seleccionar</option>
                  <option>Lima</option>
                </select>
              </div>
              <small v-if="error_district" class="text-red-600">{{
                error_district
              }}</small>
            </div>

            <div class="sm:col-span-6">
              <label
                for="input_address"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Dirección
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  id="input_address"
                  v-model="address"
                  class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
              <small v-if="error_address" class="text-red-600">{{
                error_address
              }}</small>
            </div>

            <div class="sm:col-span-6">
              <label
                for="input_bank_account"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Cuenta Bancaria
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  id="input_bank_account"
                  v-model="bank_account"
                  class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
              <small v-if="error_bank_account" class="text-red-600">{{
                error_bank_account
              }}</small>
            </div>
          </div>
        </div>
        <div class="mt-8 border-t border-gray-200 pt-5">
          <div class="flex justify-end">
            <span class="inline-flex rounded-md shadow-sm">
              <button
                type="button"
                class="py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
              >
                Cancelar
              </button>
            </span>
            <span class="ml-3 inline-flex rounded-md shadow-sm">
              <button
                @click="submitForm"
                type="submit"
                class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-primary-600 hover:bg-primary-500 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-teal-700 transition duration-150 ease-in-out"
              >
                Guardar Cambios
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </SideBar>
</template>

<script>
import api from "../../api";

import SideBar from "../../components/SideBar";
import IconSvg from "../../components/IconSvg.vue";

export default {
  name: "EditProfile",
  data() {
    return {
      hasError: false,
      dni_valid: false,
      dni: "",
      age: "",
      first_name: "",
      last_name_p: "",
      last_name_m: "",
      department: "",
      province: "",
      district: "",
      address: "",
      bank_account: "",

      error_dni: "",
      error_age: "",
      error_first_name: "",
      error_last_name_p: "",
      error_last_name_m: "",
      error_department: "",
      error_province: "",
      error_district: "",
      error_address: "",
      error_bank_account: ""
    };
  },
  async mounted() {
    let response = await api.get(`/profile`)
    if (!response.ok) {
      return
    }
    this.dni = response.data.dni || ''
    this.age = response.data.age || ''
    this.first_name = response.data.first_name || ''
    this.last_name_p = response.data.last_name_p || ''
    this.last_name_m = response.data.last_name_m || ''
    this.department = response.data.department || ''
    this.province = response.data.province || ''
    this.district = response.data.district || ''
    this.address = response.data.address || ''
    this.bank_account = response.data.bank_account || ''
  },
  methods: {
    async validateDNI() {
      let response = await api.get(`/dni/${this.dni}`)
      if (!response.ok) {
        this.dni_valid = false
        return
      }
      this.first_name = response.data.first_name
      this.last_name_p = response.data.last_name_p
      this.last_name_m = response.data.last_name_m
      this.dni_valid = true
    },
    async submitForm() {
      this.validateSubmit();
      if (this.hasError) return;
      let response = await api.post(`/profile/edit`, {
        dni: this.dni,
        age: this.age,
        first_name: this.first_name,
        last_name_p: this.last_name_p,
        last_name_m: this.last_name_m,
        department: this.department,
        province: this.province,
        district: this.district,
        address: this.address,
        bank_account: this.bank_account,
      })
      if (!response.ok) {
        return this.$toast.open({
          message: response.error || 'Ocurrió un error, vuelva a intentarlo',
          type: "error",
          duration: 8000,
          dismissible: true
        });
      }
      this.$toast.open({
        message: 'Cambios guardados',
        type: "success",
        duration: 8000,
        dismissible: true
      });
    },
    validateSubmit() {
      this.hasError = false;
      if (this.dni == "" || this.dni.length != 8) {
        this.hasError = true;
        this.error_dni = "El DNI debe tener 8 dígitos";
      } else this.error_dni = "";
      if (this.age == "" || this.age < 18 || this.age > 100) {
        this.hasError = true;
        this.error_age = "La edad debe ser mayor a 18";
      } else this.error_age = "";
      if (this.first_name == "") {
        this.hasError = true;
        this.error_first_name = "Campo obligatorio";
      } else this.error_first_name = "";
      if (this.last_name_p == "") {
        this.hasError = true;
        this.error_last_name_p = "Campo obligatorio";
      } else this.error_last_name_p = "";
      if (this.last_name_m == "") {
        this.hasError = true;
        this.error_last_name_m = "Campo obligatorio";
      } else this.error_last_name_m = "";
      if (this.department == "") {
        this.hasError = true;
        this.error_department = "Campo obligatorio";
      } else this.error_department = "";
      if (this.province == "") {
        this.hasError = true;
        this.error_province = "Campo obligatorio";
      } else this.error_province = "";
      if (this.district == "") {
        this.hasError = true;
        this.error_district = "Campo obligatorio";
      } else this.error_district = "";
      if (this.address == "") {
        this.hasError = true;
        this.error_address = "Campo obligatorio";
      } else this.error_address = "";
      if (this.bank_account == "") {
        this.hasError = true;
        this.error_bank_account = "Campo obligatorio";
      } else this.error_bank_account = "";
    }
  },
  components: {
    SideBar,
    IconSvg
  }
};
</script>